// src/components/ProtectedRoute.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import { Loader, Center } from "@mantine/core";

const ProtectedRoute = () => {
  const { token, loading } = useAuth();

  if (loading) {
    // Tampilkan spinner Mantine
    return (
      <Center style={{ height: "100vh" }}>
        <Loader />
      </Center>
    );
  }
  
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;